// Auth.tsx
import React, { useContext, useEffect, useState } from "react";
import { getToken } from "./common/utils";

interface Auth {
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
}

interface AuthInit {
  isLoggedIn: boolean;
  loading: boolean;
}

export const AuthContext = React.createContext<Auth>({ 
  isLoggedIn: false,
  setIsLoggedIn: () => {}
});

export function useAuth(): Auth {
  return useContext(AuthContext);
}

export function useAuthInit(): AuthInit {
  const [authInit, setAuthInit] = useState<AuthInit>({
    loading: true,
    isLoggedIn: false,
  });

  useEffect(() => {
    const checkAuth = () => {
      const token = getToken();
      setAuthInit({ 
        loading: false, 
        isLoggedIn: token !== null 
      });
    };
    
    checkAuth();
    
    // Optional: Listen for storage events if using localStorage
    window.addEventListener('storage', checkAuth);
    
    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  return authInit;
}